// 服务端消息推送接收
<template>
  <div>
  </div>
</template>

<script>
import HSocket from '@frame/utils/hui.socket'
import { getCurrUserInfo } from '@frame/api/login'
export default {
  name: 'wss',
  data () {
    return {
      subForm: {
        topic: 'front_mq_msg_topic',
        filter: [{ key: '', value: '' }],
        bizCheck: [{ key: '', value: '' }],
        returnFiled: '',
        replace: false,
        rebuild: true
      }
    }
  },
  created () {

  },
  mounted () {
    this.initSocket()
  },
  computed: {

  },
  props: {

  },
  methods: {
    initSocket () {
      console.log('initSocket链接...........')
      let user = this.$getCurrInfo()['userId']
      if (!user) {
        return false
      }
      let url = window.LOCAL_CONFIG.WSS_HOME
      // appData 每个页面为唯一
      let path = window.location.href
      let appData = path.substr(0, path.indexOf('#'))
      this.socket = new HSocket(user, url, appData)
      this.socket.on('on-connect', this.handleConnect)
      this.socket.on('on-connect-error', this.handleConnectError)
      this.socket.on('on-subscribe-recv', this.handleSubscribe)
      this.socket.on('on-connect-closed', this.handleConnClosed)
      this.connect()
    },
    // 连接建立成功回调
    handleConnect () {
      // 消息订阅
      this.subscribe()
    },
    subscribe () {
      console.log('消息订阅 ...........')
      this.socket.subscribe({
        ...this.buildBody(this.subForm)
      }, this.handleSubscribeSuccess)
    },
    handleSubscribeSuccess (data) {
      console.log('建立连接 订阅消息:', data)
    },
    cancelSub () {
      this.socket && this.socket.cancelSub({
        ...this.buildBody(this.subForm)
      }, this.handleCancelSubSuccess)
    },
    handleCancelSubSuccess (data) {
      console.log('断开连接 订阅消息:', data)
    },
    connect () {
      this.socket && this.socket.connect()
    },
    disconnect () {
      this.socket && this.socket.closeConn()
    },
    /* 组装消息体 */
    buildBody (form) {
      const filterArr = form.filter
      const bizCheckArr = form.bizCheck
      const filter = {}
      const bizCheck = {}
      filterArr.forEach(f => {
        if (f.key && f.key.trim()) {
          filter[f.key.trim()] = f.value
        }
      })
      bizCheckArr.forEach(f => {
        if (f.key && f.key.trim()) {
          bizCheck[f.key.trim()] = f.value
        }
      })
      return {
        messageType: 2,
        topicName: form.topic,
        filter,
        bizCheck,
        rebuild: form.rebuild,
        replace: form.replace,
        returnFiled: form.returnFiled
      }
    },
    // 接受消息
    handleSubscribe (data) {
      console.log('data----', data)
      let message = data.body
      if (message) {
        let body = JSON.parse(message)
        if (body['type'] === 'userChange') {
          this.refreshUserInfo(body)
        }
        // 询价方出价，报价方洽谈信息更新，推送报价编号、用户id
        if (body['type'] === 'replyBid') {
          this.$bus.$emit('agt-updata-replyBid', body)
        }
        // 报价方出价，询价方洽谈信息-更新，推送询价编号
        if (body['type'] === 'entrustBid') {
          this.$bus.$emit('agt-updata-entrustBid', body)
        }
      }
    },
    handleConnClosed () {
      console.log('handleConnClosed')
    },
    destroySocket () {
      console.log('销毁soketl链接...........')
      if (this.socket) {
        this.socket.destroy()
        this.socket = null
      }
    },

    // self
    refreshUserInfo (body) {
      const userId = this.$getCurrInfo()['userId']
      if (userId === body['userId']) {
        console.log('后台审核用户信息=>更新')
        getCurrUserInfo({ 'refresh': true }).then(res => {
          if (res.data.success) {
            let userAgent = res.data.userAgent
            let userMap = userAgent.userMap
            window.localStore.set('ucWsCurrUser', JSON.stringify(userMap))
            window.sessionStorage.setItem('ucWsCurrUser', JSON.stringify(userMap))
          }
        })
      }
    }
  },
  beforeDestroy () { // 在组件生命周期结束的时候销毁。
    // 取消订阅
    this.cancelSub()
    // 断开wss连接
    this.disconnect()
    // 销毁wss连接
    this.destroySocket()
  },
  watch: {

  }
}
</script>
